/**
 * Peripheral Device Detection Action Types
 */

export const SET_PERIPHERAL_RESTRICTION_ACTIVE =
  "SET_PERIPHERAL_RESTRICTION_ACTIVE";
export const SET_PERIPHERAL_ERROR = "SET_PERIPHERAL_ERROR";
export const SET_DETECTED_DEVICES = "SET_DETECTED_DEVICES";
export const SET_HAS_VIOLATING_DEVICES = "SET_HAS_VIOLATING_DEVICES";
export const SET_CHECKING_DEVICES = "SET_CHECKING_DEVICES";
export const SET_LAST_CHECK_TIME = "SET_LAST_CHECK_TIME";
export const RESET_PERIPHERAL = "RESET_PERIPHERAL";
